<div class="flex max-w-[832px] bg-beige rounded-[10px]">
  <div class="flex flex-row items-start mt-[26px] mb-[25px] sm:mt-[26px] sm:mb-[18px] space-x-[14px] sm:space-x-[17px] ml-[21px] mr-[20px] sm:ml-[42px] sm:mr-[30px]">
    <ln-info-svg-icon [class]="'w-[30px] h-[30px] mt-[4px]'"></ln-info-svg-icon>
    <div class="flex flex-col items-start space-y-[10px]">
      <div class="text-cafe text-lg font-bold sm:text-xl">{{'labels.ourPurposeAtLunaNueva' | transloco}} </div>
      <div class="text-cafe text-base font-medium">{{'labels.ourPurposeAtLunaNuevaText' | transloco}} </div>
    </div>
  </div>
</div>
